import React, { useState } from 'react';
import UserManagement from './UserManagement';
import SystemStats from './SystemStats';
import './Admin.css';

function AdminPanel() {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="admin-container">
      <h1 className="admin-title">Admin Panel</h1>

      <div className="admin-tabs">
        <button
          className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          User Management
        </button>
        <button
          className={`tab-button ${activeTab === 'stats' ? 'active' : ''}`}
          onClick={() => setActiveTab('stats')}
        >
          System Stats
        </button>
      </div>

      <div className="admin-content">
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'stats' && <SystemStats />}
      </div>
    </div>
  );
}

export default AdminPanel;
